<template>
  <h1>Sanctum of Alteration</h1>
  <MDBBtnGroup aria-label="Basic example" class="mb-4">
    <MDBRadio
      :wrap="false"
      :btnCheck="true"
      value="EW01"
      labelClass="btn btn-primary"
      label="Operation 1"
      v-model="radio"
    />
    <MDBRadio
      :wrap="false"
      :btnCheck="true"
      value="EW02"
      labelClass="btn btn-primary"
      label="Operation 2"
      v-model="radio"
    />
    <MDBRadio
      :btnCheck="true"
      :wrap="false"
      value="EW03"
      labelClass="btn btn-primary"
      label="Operation 3"
      v-model="radio"
    />
    <MDBRadio
      :btnCheck="true"
      :wrap="false"
      value="EW04"
      labelClass="btn btn-primary"
      label="Operation 4"
      v-model="radio"
    />
    <MDBRadio
      :btnCheck="true"
      :wrap="false"
      value="EW05"
      labelClass="btn btn-primary"
      label="Operation 5"
      v-model="radio"
    />
  </MDBBtnGroup>
  <div v-if="correct">
    <el-select v-model="chosenFloor">
      <el-option
        v-for="floor in floors"
        :key="floor"
        :label="'Floor ' + floor"
        :value="floor"
      >
      </el-option>
    </el-select>
    <hr />
    <enemy-sanctum-stage :enemy="activeFloor" v-if="activeFloor" />
  </div>
  <div v-else>Choose an Operation</div>
  <enemy-tab
    :enemy="this.activeEnemy[0]"
    :lvl="this.activeEnemy[1]"
    @update="updateEvent"
  />
</template>

<script>
import { MDBRadio, MDBBtnGroup } from "mdb-vue-ui-kit";
import { ElSelect, ElOption } from "element-plus";
import EnemySanctumStage from "../components/EnemySanctumStage.vue";
import EnemyTab from "../components/EnemyTab.vue";
import { ref } from "vue";

export default {
  components: {
    MDBRadio,
    MDBBtnGroup,
    ElSelect,
    ElOption,
    EnemySanctumStage,
    EnemyTab,
  },
  computed: {
    sanctum() {
      return this.$store.getters.getSanctum;
    },
    correct() {
      return this.radio in this.sanctum;
    },
    floors() {
      if (this.correct) {
        return Object.keys(this.sanctum[this.radio]);
      }
      return null;
    },
    activeFloor() {
      if (this.correct) {
        if (this.chosenFloor in this.sanctum[this.radio]) {
          return this.sanctum[this.radio][this.chosenFloor].waves;
        }
        else {
          this.resetActiveFloor();
          return this.sanctum[this.radio][this.chosenFloor].waves;
        }
      }
      return false;
    },
    activeEnemy() {
      return this.$store.getters.getActiveEnemy;
    },
  },
  setup() {
    const radio = ref("EW01");

    return {
      radio,
    };
  },
  created() {
    document.title = "Sanctum of Alteration";
  },
  data() {
    return { chosenFloor: "1" };
  },
  methods: {
    updateEvent(e) {
      if (e == false) {
        this.$store.dispatch("setActiveEnemy", ["", 0]);
      }
    },
    resetActiveFloor() {
      this.chosenFloor = 1;
    },
  },
};
</script>

<style scoped></style>
